<div class="capture-payment-dialog">
  <div class="loading-overlay" *ngIf="isSaving">
    <mat-progress-spinner mode="indeterminate" diameter="64"></mat-progress-spinner>
    <div class="loading-text">Saving payment, please wait…</div>
  </div>
  <div class="dialog-header">
    <h2 class="formHeader">New Credit/Payment</h2>
  </div>

<form [formGroup]="form" class="capture-payment-form"><br>
  <!-- <mat-form-field appearance="outline" class="full-width">
      <mat-label>Patient</mat-label>
      <input matInput formControlName="patientName" readonly>
    </mat-form-field> -->

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Payment Date</mat-label>
    <input matInput [matDatepicker]="picker" formControlName="paymentDate">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <div class="form-row">
    <mat-form-field appearance="outline" class="flex-1">
      <mat-label>Credit/Payment Type</mat-label>
      <mat-select formControlName="paymentMethod">
        <mat-option value="Cash">Cash</mat-option>
        <mat-option value="Card">Card</mat-option>

        <mat-option value="Yoco: Card Machine">Yoco: Card Machine</mat-option>
        <mat-option value="Yoco: Online">Yoco: Online</mat-option>

        <mat-option value="EFT: Patient">EFT: Patient</mat-option>
        <mat-option value="EFT: Medical Scheme">EFT: Medical Scheme</mat-option>

        <mat-option value="Credit: Pro Bono">Credit: Pro Bono</mat-option>
        <mat-option value="Credit: Bad Debt Written Off">Credit: Bad Debt Written Off</mat-option>
        <mat-option value="Credit: Discounted">Credit: Discounted</mat-option>
        <mat-option value="Credit: Refund">Credit: Refund</mat-option>
        <mat-option value="Credit: Other">Credit: Other</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="flex-1">
      <mat-label>Amount </mat-label>
      <span matPrefix class="p-l-5 p-r-5">R</span>
      <input matInput type="number" formControlName="amountRecieved">
    </mat-form-field>
  </div>


  <div formArrayName="paymentRows">
    <div *ngFor="let paymentRow of paymentRows.controls; let i = index" [formGroupName]="i" class="payment-row">

      <div class="payment-row-header">
        <h4>Payment Row {{ i + 1 }}</h4>
        <div class="row-actions">
          <button mat-icon-button color="warn" (click)="removePaymentRow(i)" matTooltip="Remove this payment row">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
      <span>{{paymentRow.get('text-secondary')?.value}}</span>
      <div class="allocation-row">
        <mat-form-field appearance="outline" class="flex-2">
          <mat-label>Invoices</mat-label>
          <mat-select formControlName="linkedInvoice">

            <mat-option *ngFor="let invoice of getAvailableInvoices(i); trackBy: trackByInvoiceId"
              [value]="invoice.invoiceId">
              #{{ invoice.billingNumber || invoice.invoiceId }} (Due: R{{ invoice.balance }})
            </mat-option>

          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>Allocated Amount</mat-label>
          <span matPrefix class="p-l-5 p-r-5">R</span>
          <input matInput type="number" formControlName="allocatedAmount">
        </mat-form-field>
      </div>

      <!-- Allocation preview for multiple invoices -->
      <div
        *ngIf="getAllocationPreview(paymentRow.get('linkedInvoice')?.value || [], paymentRow.get('allocatedAmount')?.value || 0)"
        class="allocation-preview">
        <mat-icon>info</mat-icon>
        <span>{{ getAllocationPreview(paymentRow.get('linkedInvoice')?.value || [],
          paymentRow.get('allocatedAmount')?.value || 0) }}</span>
      </div>
    </div>
  </div>

  <div class="allocation-hint" *ngIf="remainingToAllocate > 0">
    <span>R{{ remainingToAllocate }} unallocated. You can allocate it to another invoice (if available) or credit it to the patient's file.</span>
  </div>

  <button mat-raised-button color="primary" (click)="newPaymentRow()" class="add-btn"
    [disabled]="isSaving"
    *ngIf="getRemainingAmountToAllocate() > 0 && canAddMorePaymentRows()">
    <mat-icon>add</mat-icon>
    Add Payment Row
  </button>
  <!-- <div class="text-muted" *ngIf="!canAddMorePayments() && remainingToAllocate > 0">
        No more unpaid invoices to allocate remaining R{{ remainingToAllocate }}.
      </div> -->

  <!-- Payment Summary -->
  <div class="payment-summary" *ngIf="paymentRows.length > 0">
    <div class="summary-row">
      <span class="summary-label">Total Amount Received:</span>
      <span class="summary-value">R{{ getNumberValue('amountRecieved') | number:'1.2-2' }}</span>
    </div>
    <div class="summary-row">
      <span class="summary-label">Total Allocated:</span>
      <span class="summary-value">R{{ getTotalAllocatedAmount() | number:'1.2-2' }}</span>
    </div>
    <div class="summary-row" [class.over-allocated]="getRemainingAmountToAllocate() < 0">
      <span class="summary-label">Remaining to Allocate:</span>
      <span class="summary-value">R{{ getRemainingAmountToAllocate() | number:'1.2-2' }}</span>
    </div>
  </div>

  <!-- Excess Credit Option -->
  <div *ngIf="excessCredit > 0" class="excess-credit-info">
    <mat-checkbox [(ngModel)]="addExcessAsCredit" [ngModelOptions]="{standalone: true}" color="primary">
      Add excess R{{ excessCredit | number:'1.2-2' }} as credit to patient account
    </mat-checkbox>
  </div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Notes</mat-label>
    <textarea matInput formControlName="notes" rows="2"></textarea>
  </mat-form-field>

    <div class="dialog-actions">
      <button mat-button (click)="closeDialog()" [disabled]="isSaving">Cancel</button>
      <button mat-raised-button color="primary" [disabled]="disablePayment || isSaving" (click)="submitNewPayment()">
        Save
      </button>
    </div>
  </form>
</div>